export default __webpack_public_path__ + "static/media/appsIcon-filled.7fa6c8fc.svg";